export default __webpack_public_path__ + "static/footer-vespa-4d1a83f70001799dab5226e36529793b.png";